import { navigate } from '@reach/router'
import React, { useEffect, useState } from 'react'
import { TemplateProps } from '../../../journeys/journey/Interfaces'
import { Card } from "@material-ui/core";
import { Button, Spinner } from 'ams-ui-reactkit';
import { TitleBlock } from '../../../atoms';
import './EstimateForService.scss'
import { ItemBlock } from '../../../organisms';
import { getBolDetails } from '../../../graphql/getboldetails.query';
import { useContextSelector } from '@fluentui/react-context-selector';
import { StoreContext } from '../../../context';
import { getParsedValue } from "./../../../common/ParseScript";
import { getCustomerId, getRandomNumber } from '../../../utils/Utils';
import actionTypeConstants from "../../../utils/actionTypeConstants"

const EstimateForService: React.FC<TemplateProps> = (props: any) => {
    const { templateProps } = props;
    const [loading, setLoading] = useState(false);
    const appState: any = useContextSelector(StoreContext, store => store?.appState);
    const customerInfoState: any = useContextSelector(StoreContext, store => store?.appState?.customerInfo);
    const cid = getCustomerId();
    const customerId = cid ? parseInt(cid) : "";
    const dispatch: any = useContextSelector(StoreContext, store => store?.dispatch);
    const bolDetails = customerInfoState?.bolDetails || []

    useEffect(() => {
        if (customerId && bolDetails?.length === 0) {
            getBolDetailsData()
        }
    }, [])

    const getBolDataStructure = (data: any) => {
        let Arry = []

        if (data) {
            if (data?.moverCarrier) {
                Arry.push(data?.moverCarrier)
                if (data?.moverCarrier?.bolNo) {
                    dispatch({
                        'type': actionTypeConstants.BOL_NO,
                        'payload': data?.moverCarrier?.bolNo
                    })
                }
            }
            if (data?.customerDetails) {
                Arry.push(data?.customerDetails)
            }
            if (data?.serviceDates) {
                Arry.push(data?.serviceDates)
            }
        }

        return Arry
    }

    const getBolDetailsData = async () => {
        setLoading(true)
        await getBolDetails(customerId).then((dataResults: any) => {
            let bolDataStructure = getBolDataStructure(dataResults.bolDetails) || []
            dispatch({
                'type': actionTypeConstants.UPDATE_BOL_DETAILS,
                'payload': bolDataStructure
            })
            setLoading(false)
        }).catch((e: any) => {
            console.log("getBolDetails API Failed ln:35 Error:", e);
            setLoading(false)
        });
    }

    return (
        <div className="baseContainerBlock">
            {templateProps.title && <TitleBlock title={getParsedValue(templateProps.title, appState)} />}
            {loading ? <div className='flex-center-50h'>
                <Spinner />
            </div> : bolDetails && bolDetails.length > 0 && <Card className="cardStylesSecondary">
                {bolDetails.map((item: any, pageIndex: any) => <ItemBlock key={pageIndex + getRandomNumber()} {...item} />)}
            </Card>}

            <div className="staticFixedButton">
                <Button
                    text={templateProps?.button}
                    onClick={() => { navigate(templateProps?.nextScreen || '/') }}
                    color="primary"
                    variant="contained"
                    disabled={!loading && customerId ? false : true}
                    size="large"
                />
            </div>
        </div>
    )
}

export default EstimateForService
